import { c as _c } from "react/compiler-runtime";
import { type FC } from 'react';
import { FavoritesConsumer } from '@sbt-web/favorites';
import { useViewport } from '@sbt-web/hooks';
import { FeatureURI, type AdItem } from '@sbt-web/network/types';
import { ShareComponent } from '@sbt-web/share-button';
import { Badge } from '@sbt-web/ui';
import FavoritesContainer from '@/client/components/Search/Containers/FavoritesContainer';
import { AD_SHARING_TITLE } from '@/shared/constants';
import { onEngage, onSave, onUnsave } from '@/shared/helpers/Favorites/trackingEvents';
import classes from './SocialBar.module.scss';
interface Props {
  ad: AdItem;
  onSaveFavorite?: () => void;
  onUnsaveFavorite?: () => void;
  subject?: string;
}
const SocialBar: FC<Props> = t0 => {
  const $ = _c(22);
  const {
    ad,
    onSaveFavorite,
    onUnsaveFavorite
  } = t0;
  const {
    category,
    urn,
    features
  } = ad;
  const itemSold = features[FeatureURI.TransactionStatus] != undefined;
  const {
    isDesktop
  } = useViewport();
  let t1;
  if ($[0] !== onSaveFavorite || $[1] !== urn) {
    t1 = () => {
      onSaveFavorite?.();
      onSave(urn, "ad-detail");
    };
    $[0] = onSaveFavorite;
    $[1] = urn;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleOnSave = t1;
  let t2;
  if ($[3] !== onUnsaveFavorite || $[4] !== urn) {
    t2 = () => {
      onUnsaveFavorite?.();
      onUnsave(urn, "ad-detail");
    };
    $[3] = onUnsaveFavorite;
    $[4] = urn;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleOnUnsave = t2;
  let t3;
  if ($[6] !== urn) {
    t3 = () => {
      onEngage(urn);
    };
    $[6] = urn;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleOnEngage = t3;
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = [classes["label-category"]];
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== category.label) {
    t5 = <Badge classes={t4}>{category.label}</Badge>;
    $[9] = category.label;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== category || $[12] !== handleOnEngage || $[13] !== handleOnSave || $[14] !== handleOnUnsave || $[15] !== isDesktop || $[16] !== itemSold || $[17] !== urn) {
    t6 = itemSold ? null : <div className={classes.buttons}><FavoritesContainer onSave={handleOnSave} onUnsave={handleOnUnsave} onEngage={handleOnEngage}><ShareComponent design="text" className={classes["share-button"]} adTrackInfo={{
          urn,
          category,
          trackIds: {
            shareButton: () => isDesktop ? "sharing-icon-near-ad" : "sharing-icon-under-ad",
            closeModal: () => isDesktop ? "close-sharing-near-ad-modal" : "close-sharing-under-ad-modal",
            shareWithNativeApi: "sharing-icon-under-ad-customsocial",
            messenger: "sharing-icon-near-ad-mess",
            facebook: "sharing-icon-near-ad-facebook",
            whatsApp: "sharing-icon-near-ad-whatsapp",
            copyUrl: "sharing-icon-near-ad-copylink"
          }
        }} sharingTitle={AD_SHARING_TITLE} sharingUrl={_temp} /><FavoritesConsumer urn={urn} /></FavoritesContainer></div>;
    $[11] = category;
    $[12] = handleOnEngage;
    $[13] = handleOnSave;
    $[14] = handleOnUnsave;
    $[15] = isDesktop;
    $[16] = itemSold;
    $[17] = urn;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t5 || $[20] !== t6) {
    t7 = <div className={classes["action-bar"]}>{t5}{t6}</div>;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
};
export default SocialBar;
function _temp() {
  const canonicalLink = document.querySelector("link[rel='canonical']");
  const link = canonicalLink?.href ?? window.location.href;
  return `${link}?utm_medium=referral&utm_source=subito&utm_campaign=free-engagement-ad_detail`;
}